<template>
  <div v-if="show">
    <v-card style="margin-left: 15px; margin-top: 15px" max-width="344">
      <v-list-item three-line>
        <v-list-item-content>
          <div class="overline mb-4">Student Info</div>
          <v-list-item-title class="headline mb-1">{{
            name
          }}</v-list-item-title>
          <v-list-item-subtitle
            >Standard:<b>{{ standard }}</b></v-list-item-subtitle
          >
          <v-list-item-subtitle
            >Division: <b>{{ division }}</b></v-list-item-subtitle
          >
          <v-list-item-subtitle
            >Roll Number: <b>{{ rollno }}</b></v-list-item-subtitle
          >
        </v-list-item-content>

        <v-avatar color="info" size="48">
          <span class="white--text headline">{{ name[0] }}</span>
        </v-avatar>
      </v-list-item>
    </v-card>

    <chart
      @click="onClick"
      :options="option"
      :loading="month_attendance_graph_load"
    ></chart>
    <div v-if="showtable">
      <v-data-table :headers="headers" :items="records" :search="search">
        <template v-slot:top>
          <v-toolbar flat color="white" align="center" justify="center">
            <v-toolbar-title>Attendance Details</v-toolbar-title>

            <v-divider class="mx-4" inset vertical></v-divider>
            <v-spacer></v-spacer>
            <v-text-field
              v-model="search"
              append-icon="search"
              label="Search"
              single-line
              hide-details
              class="no-display"
            ></v-text-field>
          </v-toolbar>
        </template>
      </v-data-table>
    </div>
  </div>
</template>
<script>
import axios from "axios";
export default {
  data: () => ({
    show: false,
    showtable: false,
    childinfo: "",
    headers: [
      { text: "Day No", value: "dayno" },
      { text: "Date", value: "date" },
      { text: "Status", value: "status" },
    ],
    awspath: localStorage.getItem("awspath"),
    records: "",
    search: "",
    avtarlocation: "",
    month_attendance_graph_load: true,
    name: "",
    standard: "",
    division: "",
    rollno: "",
    option: {
      color: ["#3398DB"],
      xAxis: {
        type: "category",
        data: [
          "JAN",
          "FEB",
          "MAR",
          "APR",
          "MAY",
          "JUN",
          "JUL",
          "AUG",
          "SEP",
          "OCT",
          "NOV",
          "DEC",
        ],
      },
      yAxis: {
        type: "value",
        max: 31,
      },
      legend: {
        data: ["X-axis:Month", "Y-axis:# Days"],
      },
      series: [
        {
          data: [],
          value: [],
          type: "bar",
        },
      ],
    },
  }),

  mounted() {
    this.show = true;
    this.viewattendance();
  },
  methods: {
    viewattendance() {
     
     
      if (this.$store.getters.lid == null || this.$store.getters.cay_id ==null ) {
        //alert('divoff')
        this.$router.push({ name: "child-attendance" });
      }
      //this.divoff=this.$store.getters.divoff_id
      const data = {
        learner: this.$store.getters.lid,
        cay: this.$store.getters.cay_id,
      };

      axios
        .post("/Academics/getMyChildAttendance", data)
        .then((res) => {
          if (res.data.msg == "200") {
            this.option.series[0].data = res.data.value;
            this.option.series[0].value = res.data.data;
            this.name = res.data.name;
            this.division = res.data.division;
            this.standard = res.data.standard;
            this.rollno = res.data.rollno;
            this.avtarlocation = res.data.avtarlocation;

            this.option.series[0].label = {
              normal: {
                show: true,
                position: "top",
                formatter: (params) => {
                  let outof = this.option.series[0].value[params.dataIndex]; //this.series[0].data[params.dataIndex];;
                  let total = this.option.series[0].data[params.dataIndex];
                  // this.series[0].forEach(serie => {
                  //   // total += serie.data[0];
                  // })
                  return total + "/" + outof;
                },
              },
            };
            //this.load=true
          } else {
          }
        })
        .catch((error) => {
          window.console.log(error);
        });
    },
    onClick(event, instance) {
      console.log(arguments);
      console.log(arguments[0].name);
      console.log(arguments[0].value);
      const data = {
        learner: this.$store.getters.lid,
        month: arguments[0].name,
      };

      axios
        .post("/Academics/getMyChildMonthAttendance", data)
        .then((res) => {
          if (res.data.msg == "200") {
            this.records = res.data.records;

            this.showtable = true;
          } else {
          }
        })
        .catch((error) => {
          window.console.log(error);
        });
    },
  },
};
</script>